import { ICotizacionValues } from '../Providers/CotizacionStore';
import { esLandingDeVendedor } from './rutaVendedor';

/**
 * Entradas públicas al cotizador (US 23866): si la pestaña tenía una cotización del asesor, pasa a ser
 * de cliente (landing actual y sin vendedor), así no ve los textos del asesor ni el lead se registra como
 * venta presencial. A una cotización de cliente no le cambia nada: se devuelve el mismo objeto.
 */
export const quitarMarcaDeVendedor = (valores: ICotizacionValues, urlActual: string): ICotizacionValues =>
  esLandingDeVendedor(valores.landingUrl) ? { ...valores, landingUrl: urlActual, ventaPresencial: undefined } : valores;
